export default __webpack_public_path__ + "static/media/affinity-capital-atticus-app-partner.f5291bd0.svg";